import { navigateTo, useRoute } from '#imports'
import { computed } from 'vue'

const FINANCIAL_DETAILS = 'financial-details'
const ORDER_DETAILS = 'order-details'

export function useOrderRecapDrawer() {
  const route = useRoute()

  async function openOrderDetails(orderId: string | number) {
    await navigateTo({
      path: route.path,
      query: { ...route.query, orderId },
      hash: `#${ORDER_DETAILS}=${orderId}`,
    })
  }

  async function openFinancialDetails(orderId: string | number) {
    await navigateTo({
      path: route.path,
      query: { ...route.query, orderId },
      hash: `#${FINANCIAL_DETAILS}=${orderId}`,
    })
  }

  async function closeRecapDrawer() {
    await navigateTo({
      path: route.path,
      query: route.query,
    })
  }

  const isFinancialDetailsVisible = computed(() =>
    route.hash.includes(FINANCIAL_DETAILS),
  )

  const isOrderDetailVisible = computed(() =>
    route.hash.includes(ORDER_DETAILS),
  )

  const orderId = computed(() => {
    if (route.hash) {
      const [, id] = route.hash.split('=')

      return id
    }

    return undefined
  })

  return {
    openOrderDetails,
    openFinancialDetails,
    closeRecapDrawer,
    isFinancialDetailsVisible,
    isOrderDetailVisible,
    orderId,
  }
}
